import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxySnackbarModule, SnackbarService } from '@vendasta/galaxy/snackbar-service';

import {
  MarketplaceProductModule,
  StencilsModule,
  StoreModule,
  VaPackageDetailsV2Module,
  VaSalespersonDetailsModule,
} from '@vendasta/store';
import { VaBreadcrumbsModule } from '@vendasta/uikit';
import { AppViewComponent } from './app-view/app-view.component';
import { CartRedirectComponent } from './cart-redirect/cart-redirect.component';
import { InterestInPackageDialogComponent } from './interest-in-package-dialog/interest-in-package-dialog.component';
import { PackageViewComponent } from './package-view/package-view.component';
import { BusinessService } from './services/business.service';
import { CookieService } from './services/cookie.service';
import { FeatureFlagService } from './services/featureFlag.service';
import { GooglePlacesService } from './services/google-places/google-places.service';
import { PackageInterestService } from './services/package-interest/package-interest.service';
import { StoreHeaderComponent } from './store-header/store-header.component';
import { StorefrontRoutingModule } from './storefront-routing.module';
import { StorefrontComponent } from './storefront.component';
import { StorefrontService } from './storefront.service';
import { TileViewComponent } from './tile-view/tile-view.component';

@NgModule({
  declarations: [
    StorefrontComponent,
    PackageViewComponent,
    TileViewComponent,
    InterestInPackageDialogComponent,
    StoreHeaderComponent,
    CartRedirectComponent,
    AppViewComponent,
  ],
  imports: [
    RouterModule.forRoot([], {}),
    StorefrontRoutingModule,
    CommonModule,
    BrowserModule,
    StoreModule,
    VaPackageDetailsV2Module,
    VaBreadcrumbsModule,
    VaSalespersonDetailsModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatIconModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatInputModule,
    TranslateModule,
    MatSnackBarModule,
    StencilsModule,

    GoogleMapsModule,
    MarketplaceProductModule,
    GalaxySnackbarModule,
  ],
  providers: [
    BusinessService,
    PackageInterestService,
    CookieService,
    SnackbarService,
    FeatureFlagService,
    GooglePlacesService,
  ],
  exports: [StorefrontComponent],
})
export class StorefrontModule {
  static forRoot(environment: any): ModuleWithProviders<any> {
    return {
      ngModule: StorefrontModule,
      providers: [StorefrontService, GooglePlacesService, { provide: 'enviroment', useValue: environment }],
    };
  }
}

export { StorefrontComponent } from './storefront.component';
export { StorefrontService } from './storefront.service';
